var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 145,
    viewBox: "0 0 115 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 116C0 93.9086 17.9086 76 40 76H75C97.0914 76 115 93.9086 115 116V145H0V116Z",
    fill: "#EF4443"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88 31.5C88 48.897 73.897 63 56.5 63C39.103 63 25 48.897 25 31.5C25 14.103 39.103 0 56.5 0C73.897 0 88 14.103 88 31.5Z",
    fill: "#EF4443"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActUser);
export default __webpack_public_path__ + "static/media/act-user.18b78726c8d991fc994b0cd717a5eac0.svg";
export { ForwardRef as ReactComponent };